import React, { Dispatch, SetStateAction, useState } from "react";
import Modal from "react-modal";
import process from "process";
import { useQuery } from "react-query";
import { queryKeys } from "@/queries/queryKeys";
import axios from "axios";
import classNames from "classnames";
import Step1 from "@/components/Modal/QualificationModalSteps/Step1";
import Step2 from "@/components/Modal/QualificationModalSteps/Step2";
import { SVGClose } from "@/images/svg/svg-icons";

interface Answer {
  title: string;
  value: boolean;
}

export interface QualificationModalProps {
  onClose: any;
  isOpen: boolean;
  requireSecurityGuard: boolean;
  setOpenConfirmationModal: Dispatch<SetStateAction<boolean>>;
}

export default function QualificationModal({
  onClose,
  isOpen,
  requireSecurityGuard,
  setOpenConfirmationModal,
}: QualificationModalProps) {
  const url = `https://api-us.storyblok.com/v2/cdn/stories/modals/qualification-license-inquire?token=${process.env.NEXT_PUBLIC_STORYBLOK_API_KEY}&version=published`;
  const { data, isLoading } = useQuery(queryKeys.qualificationModal, () =>
    axios.get(url)
  );
  const story = data?.data?.story?.content;

  const [answer, setAnswer] = useState<Answer[]>([]);
  const [answerSecondTab, setAnswerSecondTab] = useState<Answer[]>([]);
  const [successStep, setSuccessStep] = useState<Answer[]>([]);
  const [error, showError] = useState(false);
  const [step, setStep] = useState(1);

  function onSubmit() {
    if (requireSecurityGuard && step != 2) {
      setStep(step + 1);
      setAnswer([]);
    } else {
      onClose();
      setOpenConfirmationModal(true);
    }
  }
  return (
    <Modal
      ariaHideApp={false}
      onRequestClose={onClose}
      isOpen={isOpen}
      closeTimeoutMS={100}
    >
      <div className="content md:w-[636px] w-full">
        <div className="close" onClick={onClose}>
          <SVGClose />
        </div>
        {!isLoading && (
          <div>
            <div className="p-4 md:pb-6 pb-4">
              <h4 className="mb-1 pr-8">{story.title}</h4>
              <p className="text-main-neutrals text-base">
                {story.description}
              </p>
            </div>
            <div className="hor-line"></div>
            {step === 1 && (
              <Step1
                questionsBlocks={story.questions_blocks}
                answer={answer}
                setAnswer={setAnswer}
                type={"checkbox"}
              />
            )}

            {requireSecurityGuard && step === 2 && (
              <Step2
                questionsBlocks={story.questions_second_blocks}
                answer={answerSecondTab}
                setAnswer={setAnswerSecondTab}
                setSuccessStep={setSuccessStep}
                showError={showError}
                error={error}
                type={"radio"}
              />
            )}

            <div className="flex md:justify-end justify-between gap-2 p-4">
              <button
                onClick={onClose}
                className="button-close md:w-auto w-1/2"
              >
                Close
              </button>
              <button
                type="submit"
                className={classNames(
                  "button-next md:w-auto w-1/2",
                  (step === 1 &&
                    answer.length === story.questions_blocks.length &&
                    "active") ||
                    (step === 2 && successStep && "active")
                )}
                onClick={onSubmit}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
